<template>
  <b-modal
    id="ModalItemsPreventiva"
    :title="`${$t('Serviços')}/${$t('Peças')}`"
    size="lg"
    hide-footer
  >
    <div v-if="item === 'loading'" class="text-center py-4">
      <b-spinner small></b-spinner>
      <p class="mt-2 mb-0">Carregando...</p>
    </div>

    <div v-else-if="item && item.length">
      <table class="table table-striped table-bordered align-middle mt-2">
        <thead class="thead-light">
          <tr>
            <th>{{ $t('Descrição') }}</th>
            <th>{{ $t('Tipo') }}</th>
            <th>{{ $t('Quantidade') }}</th>
            <th>{{ $t('Valor') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(it, index) in item" :key="index">
            <td>{{ it.item.ds_item }}</td>
            <td>{{ it.item.tipo.ds_tipoitem }}</td>
            <td>{{ Number(it.qt_quantidade).toLocaleString('pt-BR') }}</td>
            <td>{{ Number(it.vl_unitario).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="text-center text-muted py-3">
      {{ $t('Nenhum resultado encontrado') }}
    </div>

    <div class="w-100">
      <div class="row center" style="justify-content: center;">
        <b-button class="mr-2" variant="danger" size="lg" @click="fecharModalPreventiva">
          {{ $t('Fechar') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalItemsPreventiva',
  props: {
    item: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    fecharModalPreventiva() {
      this.$bvModal.hide('ModalItemsPreventiva')
    }
  }
}
</script>

<style scoped>
#modalItems {
  pointer-events: none !important;
  height: 750px !important;
}

.close {
  display: none !important;
}

#totalPecas {
  height: 340px !important;
  overflow-x: auto !important;
}

.modal-content {
  height: 700px !important;
}

.table {
  font-size: 0.9rem;
}

.b-modal .modal-body {
  padding: 1.5rem;
}
</style>
